import type { LinkKind } from './linkState';

/*
 * Every word the two sub-pages show, in one place the build and the tests
 * both quote (P27). The wireframe's texts (part 2, 12 October 2026: p.6
 * Fundraising, p.5 Volunteer Recruitment) are copied word for word; the
 * undrawn ones are the developer's (P31). The client may reword the
 * disclosures (C4) and the undrawn texts (C7): one edit here.
 */

/** Fundraising's lead-in above the three disclosure panels (p.6). */
export const FUNDRAISING_LEAD_IN =
  'ActivistARC automatically displays standardized external-link and fundraising disclosures. Organizations cannot modify this language.';

/** The three fixed disclosure panels, in the wireframe's order (p.6). */
export const FUNDRAISING_PANELS = [
  {
    title: 'Standardized Donate Action',
    text: 'The ARC uses the same Donate label and icon for every organization.',
  },
  {
    title: 'External Donation Page',
    text: "The supporter opens the organization's secure fundraising page after acknowledging the standard notice.",
  },
  {
    title: 'Click Tracking',
    text: 'ActivistARC records donation-link clicks but does not process or confirm completed donations.',
  },
] as const;

/** Volunteer Recruitment's method choice (p.5). */
export const RECRUITMENT_METHOD = {
  title: 'Recruitment Method',
  description:
    "Build a custom ActivistARC form or connect your organization's existing volunteer form.",
  native: {
    title: 'Custom In-App Form',
    description: 'Build and track volunteer submissions in ActivistARC.',
  },
  external: {
    title: 'External Form Link',
    description: 'Send supporters to your existing signup form.',
  },
  availableSoon: 'Available soon',
} as const;

/** What differs between the two pages' shared parts. */
export interface LinkCopy {
  title: string;
  subtitle?: string;
  /** The app's fixed button label (P1). */
  button: 'Donate' | 'Volunteer';
  cardTitle: string;
  /** Also P21's Not set hint (P33). */
  cardDescription: string;
  fieldLabel: string;
  fieldHelper: string;
}

export const LINK_COPY: Record<LinkKind, LinkCopy> = {
  fundraising: {
    title: 'Fundraising',
    button: 'Donate',
    cardTitle: 'Fundraising Link',
    cardDescription:
      'The standardized Donate button will appear automatically when this link is published.',
    fieldLabel: 'Donation Page URL',
    fieldHelper:
      'Use the full secure URL beginning with https://. Campaign tracking parameters may be included.',
  },
  volunteer: {
    title: 'Volunteer Recruitment',
    subtitle: 'Create and manage the volunteer signup experience connected to your ARC.',
    button: 'Volunteer',
    cardTitle: 'Volunteer Form Link',
    cardDescription:
      'The standardized Volunteer button will appear automatically when this link is published.',
    fieldLabel: 'Volunteer Form URL',
    fieldHelper: 'Use the full secure URL beginning with https://.',
  },
};
